import { render, staticRenderFns } from "./SidebarLinks.vue?vue&type=template&id=400d2a76&scoped=true&"
import script from "./SidebarLinks.vue?vue&type=script&lang=js&"
export * from "./SidebarLinks.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLinks.vue?vue&type=style&index=0&id=400d2a76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400d2a76",
  null
  
)

export default component.exports